import { createAction } from '@reduxjs/toolkit';
import { PAGE_URLS } from 'utils/constants';

const fetchUsersRegion = createAction(
  `${PAGE_URLS.REGION.name}/fetchUsersRegion`,
);

export { fetchUsersRegion };
